import {InjectionToken} from '@angular/core'
import {OrderEmbeddedService} from '@service/orders/order/order.embedded.service'
import {OrderService} from '@service/orders/order/order.service'
import type {EmbeddedClientService} from '@service/embeddingService/embedded-client.service'

/**
 * Factory que resuelve la implementación adecuada de `OrderService`.
 *
 * @description
 * Devuelve `OrderEmbeddedService` cuando la app corre embebida y
 * `OrderService` en modo standalone. `OrderService` es la puerta de
 * entrada de dominio para consultar, crear y modificar pedidos.
 *
 * @param embeddedClientService Cliente que detecta si la app corre embebida.
 * @returns Instancia activa de `OrderService`.
 */
export function providerOrderFactory(embeddedClientService: EmbeddedClientService) {
  if (embeddedClientService.isEmbeddedFunction()) {
    return new OrderEmbeddedService()
  }
  return new OrderService()
}

/**
 * `InjectionToken` que referencia la instancia activa de `OrderService`.
 *
 * @description
 * Registrado en `SERVICE_PROVIDERS` junto con {@link providerOrderFactory}.
 */
export const OrderServiceToken = new InjectionToken<OrderService>('OrderService')
